import React from 'react';
import { useTranslate } from 'react-redux-multilingual'
import { constructionDocument} from "@gull";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowCircleLeft,faArrowCircleRight } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';
import swal from "sweetalert2";
import { useHistory } from "react-router-dom";

const PreviousNextBtn = (props) =>{
    const t = useTranslate();
    const history = useHistory();

    const handleChangeDoc = async (name,numero) => {//avant je relancer le construct, mais je sais pas trop pourquoi donc j'arrête de reancer parceque c'est chiant
        props.setLoadingPrevNext(true)
        let prevNextNum = name=='prev' ? +numero - 1 : +numero + 1
        let paramCampany = (props.allInfos.other_company_id!=null) ? '/'+props.allInfos.other_company_id : ''

        const response = await axios.get(process.env.REACT_APP_API_URL+'api/facture/invoice/get_one_by_number/'+prevNextNum+'/'+props.allInfos.type+paramCampany
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
            }
            else{   
                let data = {}
                constructionDocument(props.setLoadingPrevNext,response.data.data.id,props.callBackConstruct,t,data,props.setItemsBilling,props.setAllInfos,false,props.setDatasPdf)
                props.setNoReloadNeeded(true)
                history.push("/invoice/details/"+response.data.data.id)
            }
        }).catch((error) => {
            if(error=='end_session') return;
            let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(errorName), "", "error");
        })
    };

    return (
        <span className='fs-4'>
            {!props.previousNextValid.previous || Object.keys(props.allInfos).length==0 ?
                <FontAwesomeIcon className='text-light' icon={faArrowCircleLeft} />
            :
                <FontAwesomeIcon className='pointer' onClick={()=>handleChangeDoc('prev',props.allInfos.bar.split('-')[1])} icon={faArrowCircleLeft} />
            }&nbsp;&nbsp;&nbsp;&nbsp;
            {!props.previousNextValid.next || Object.keys(props.allInfos).length==0 ?
                <FontAwesomeIcon className='text-light' icon={faArrowCircleRight} />
            :
                <FontAwesomeIcon className='pointer' onClick={()=>handleChangeDoc('next',props.allInfos.bar.split('-')[1])} icon={faArrowCircleRight} />
            }
        </span>
    )
};

export default PreviousNextBtn;